<template>
  <div class="successful">
    <div>
      <div class="successful_icon"></div>
      <div class="successful_content">{{content}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "successful",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
</style>